import axios from 'axios';
import {apiServerHost} from '../common/APIServerSettings';

const createEntity = (callBackFunc, topicID, entityName, entityValueArray) => {
  const params = new URLSearchParams();
  params.append("topicID", topicID);
  params.append("entityName", entityName);
  params.append("entityArray", entityValueArray);
  axios.post(apiServerHost + "/manage/topic/builder/create/entity", params)
  .catch( error => {
    
  })
  .then( response => {
    callBackFunc(response);
  })
}

export {createEntity};